import breakpoints from './constants/breakpoints';
import { ColorMap, ColorPalette, Colors } from './types';

let formattedBreakpoints: { [key: string]: string } = {};
const breakpointEntries = Object.entries(breakpoints);
for (const [key, value] of breakpointEntries) {
  formattedBreakpoints[key] = value + 'px';
}

const requiredPaletteColors = ['primary', 'white'];

export default function<P extends ColorPalette, T extends ColorMap, A extends ColorMap>(colors: Colors<P, T, A>) {
  
  requiredPaletteColors.forEach((requiredColor) => {
    if (!colors.palette[requiredColor]) {
      throw new Error(`Please include "${requiredColor}" in your theme's color palette.`);
    }
  });

  return {
    colors: colors.palette,
    fontFamily: {
      'serif': ['SourceSerifPro', 'serif'],
      'sans': ['Roboto', 'Helvetica Neue', 'Helvetica', 'sans-serif'],
      'body': ['Roboto', 'Helvetica Neue', 'Helvetica', 'sans-serif'],
    },
    boxShadow: {
      soft: '3px 3px 5px rgba(227, 232, 252, 0.68)',
      realSoft: '1px 2px 20px rgba(0, 0, 0, 0.11);',
      DEFAULT: '2px 4px 4px rgba(0, 0, 0, 0.1)',
      md: '3px 4px 11px rgba(0, 0, 0, 0.1)',
      lg: '5px 4px 24px rgba(55, 55, 61, 0.12)',
      xl: '4px 2px 30px rgba(37, 55, 70, 0.3)',
      '2xl': '-8px 31px 44px rgba(71, 104, 130, 0.56)',
      outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
      none: 'none',
    },
    screens: formattedBreakpoints,
    extend: {
      textColor: colors.textColors,
      fontSize: {
        xxs: '.75rem',
      },
      lineHeight: {
        '2': '.5rem',
      },
      flex: {
        freeze: '0 0 auto',
      },
      fill: (theme: any) => ({
        primary: theme('colors.primary'),
        white: theme('colors.white'),
      }),
      borderRadius: {
        xlarge: '50px',
      },
      borderWidth: {
        '1.5': '1.5px',
        '3': '3px',
        '4': '4px',
        '5': '5px',
        '6': '6px',
        '12': '12px',
      },
      spacing: {
        '14': '3.5rem',
      },
      grayscale: ['hover'],
    },
  };
}
